export const CREATE_COMPANY_DOCUMENT = "CREATE_COMPANY_DOCUMENT";
export const FETCH_COMPANY_DOCUMENTS = "FETCH_COMPANY_DOCUMENTS";
export const FETCH_COMPANY_DOCUMENT = "FETCH_COMPANY_DOCUMENT";
export const EDIT_COMPANY_DOCUMENT = "EDIT_COMPANY_DOCUMENT";
export const DELETE_COMPANY_DOCUMENT = "DELETE_COMPANY_DOCUMENT";
